{
  "de": {
    "voiceRecorder": {
      "hints": {
        "transcribing": "Transkribiere Audioaufnahme..."
      }
    }
  }
}
